<template>
    <ui-sidebar-float
        ref="products-steps-step-four-unity-categories-sidebar"
        :overlay-close="false"
        :show-overlay="false"
        position="left"
        icon="far fa-cog"
        name="products-steps-step-four-unity-categories-sidebar"
        title="Categoria das unidades"
        :text="sidebarText">

        <ui-no-content-box
            v-if="loading"
            :load="loading"
            icon="fas fa-tags"
            text="Nenhum categoria encontrada."
            go-to="/" />

        <div v-else class="sidebar-content">
            <div class="groups">
                <ui-group
                    v-for="(group, index) in categories"
                    :key="index"
                    :data="group"
                    :index="index"
                    @group-changed="groupChangeHandler" />
            </div>
        </div>

        <template #footer>
            <ui-button type="button" design="lg success block" @click="save">Salvar alterações</ui-button>
        </template>
    </ui-sidebar-float>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons';
	import { uiSidebarFloat } from '@/components/ui';
	import { uiNoContentBox } from '@/components/ui';
	import { mapGetters } from 'vuex'
	import uiGroup from './group';


	export default {
		name:"ui-sidebar",
		components: {
			uiButton,
			uiNoContentBox,
			uiSidebarFloat,
			uiGroup,
		},

		computed: {
            ...mapGetters('product', {
                product: 'getProduct'
            })
		},

		// eslint-disable-next-line vue/order-in-components
		data: function () {
			return {
				/**
				 * Value used to define page content loading
				 * after fetching the data it must be set to false
				 */
				loading: true,

				/**
				 * Default value for the 'Sidebar' component subtitle
				 */
				sidebarText: 'Selecione uma ou mais categorias.',

				/**
				 * Test array just to populate the component
				 */
				categories: [{
						'name': 'Casa Nova',
						'color': '#172b46',
						'selected': true,
					},
					{
						'name': 'Casa de esquina Com 2 Andares',
						'color': '#3CA569',
						'selected': false,
					},
					{
						'name': 'Casa 2 Andares',
						'color': '#0073C8',
						'selected': true,
					},
					{
						'color': '#FF9B0F',
						'name': '1',
						'selected': false,
					},
					{
						'color': '#FF5975',
						'name': '2',
						'selected': false,
					},
					{
						'color': '#1fc6dc',
						'name': '3',
						'selected': false,
					},
					{
						'color': '#5ac387',
						'name': '4',
						'selected': true,
					},
				]
			}
		},
		updated: function () {
			this.$nextTick(() => {
				/**
				 * For development time only
				 * component update log
				 */
                // console.log(this._data);
			});
		},

		created: function () {
			this.$nextTick(() => {
				/**
				 * Event that comes from the Sidebar component
				 * Occurs when clicking on the sidebar close button
				 */
				this.$root.$on('sidebar-close-products-steps-step-four-unity-categories-sidebar', () => {
					this.closeSidebarHandler()
				});

				/**
				 * Event that comes from the Sidebar component
				 * Occurs when showing the sidebar
				 * Changes the title of the modal with the number of units that will be affected
				 */
				this.$root.$on('sidebar-open-products-steps-step-four-unity-categories-sidebar', amount => {
					this.sidebarText = `${amount} Unidades serão afetadas.`
				});
			});

			this.$nextTick(() => {
				/**
				 * Only for demonstration of loading and screen without content
				 */
				setTimeout(() => {
					this.loading = false;
				}, 3000)
			});

		},

		methods: {
			/**
			 * Event that comes from the 'Save' button,
			 * Save changes made to 'SIDEBAR'
			 */
			save: function () {

				console.log(this.product);
				console.log('save');
			},

			/**
			 * Event that comes from the sidebar component,
			 * When closing the sidebar, check for unsaved changes
			 * (if yes, it shows a confirmation prompt.)
			 */
			closeSidebarHandler: function () {
				console.log('closeSidebarHandler');
			},

			/**
			 * Event that comes from the child component,
			 * occurs when a category is selected
			 */
			groupChangeHandler: function (data) {
				console.log('groupChangeHandler:', data);
			},
		},
	}
</script>


<style lang="stylus" scoped>
	@import './styles.styl';
</style>